import Divider from '@mui/material/Divider'

const FamilyFormSubtitle = ({ children }) => {
  return (
    <Divider sx={{ mb: 3 }}>{children}</Divider>
  )
}

export default FamilyFormSubtitle